<template>
    <div class="home">
        <img alt="Vue logo" src="../assets/logo.png" />
        Welcome to the Intellitask Admin Dashboard
    </div>
</template>

<script lang="ts">
export default {
    name: 'Home',
    components: {}
};
</script>
